import { useCallback } from 'react';

import { DEFAULT_ADDITIONAL_OPTION_THRESHOLD, DEFAULT_PRODUCT_QUANTITY } from '@utils/constant';

import { mappingProductsListPayload } from './useMappingProductsList';

export const useConvertAdditionalOptionsActive = () => {
  /** @param {Object} additionalOptionsActive */
  return useCallback((additionalOptionsActive) => {
    if (Object.keys(additionalOptionsActive).length) {
      let dataConverted = {};
      for (const [key, value] of Object.entries(additionalOptionsActive)) {
        dataConverted[key] = {
          Products: [{ ProductId: value }]
        };
      }

      return dataConverted;
    }

    return {};
  }, []);
};

export const useMappingAdditionalOptions = () => {
  return useCallback(
    /** @param {Object} additionalOptions */
    (additionalOptions) => {
      if (Object.keys(additionalOptions)?.length) {
        let result = Object.keys(additionalOptions).map(() => (
          []
        ));
        // eslint-disable-next-line no-unused-vars
        for (const [index, value] of Object.keys(additionalOptions).entries()) {
          if (additionalOptions[value]?.Products?.length) {
            result[index] =
              [
                ...result[index],
                ...(
                  additionalOptions[value].Products.map((product) => (
                    {
                      ...mappingProductsListPayload({
                        productId: product.ProductId,
                        variantId: product.VariantId || '',
                        lineQuantity: DEFAULT_PRODUCT_QUANTITY,
                        BOPISThreshold: product.BOPISThreshold || DEFAULT_ADDITIONAL_OPTION_THRESHOLD
                      })
                    }
                  ))
                )
              ];
          }
        }

        return result;
      }

      return [];
    }, []);
};